import styled from 'styled-components';
import { defaultBackground, defaultColors, defaultBorder } from '../../styles/style-guide';

export const MainButton = styled.button<{
  $colorText?: string;
  $backgroundColor?: string;
  $backgroundColorHover?: string;
}>`
  height: 40px;
  width: 100%;
  max-width: 240px;
  background-color: ${({ $backgroundColor }) => $backgroundColor || defaultBackground.primary};
  color: ${({ $colorText }) => $colorText};
  border-radius: 0.375rem;
  text-align: center;
  font-size: 0.875rem;
  display: flex;
  align-items: center;
  justify-content: center;
  &:hover {
    /* background-color: ${({ $backgroundColorHover }) => $backgroundColorHover}; */
    opacity: .85;
  }
  &:disabled {
    color: #010001;
    background-color: #f5f5f5;
  }
`;

export const SecondaryButton = styled.button<{ $backgroundColor?: string; $color?: string; $borderColor?: string }>`
  height: 40px;
  width: 100%;
  max-width: 200px;
  border: 1px solid ${({ $backgroundColor }) => $backgroundColor || defaultBackground.primary};
  color: ${({ $color }) => $color || defaultColors.primary};
  border-radius: 0.375rem;
  text-align: center;
  font-size: 0.875rem;
  &:hover {
    opacity: .85;
  }
`;
